<!-- sign-in.component.html -->
<div class="container-fluid bg-light">
  <div class="row justify-content-center align-items-center vh-100">
    <div class="col-12 col-md-10 col-lg-9">
      @if (view === "login") {
        <div class="view-wrapper" [class.hidden]="view !== 'login'">
          <form
            class="card shadow-sm border-0 rounded-4 overflow-hidden"
            [formGroup]="form"
            (submit)="handleSubmit()"
          >
            @if (loading) {
              <div class="loader"></div>
            }

            <div class="card-body p-5 pb-0">
              <div class="row align-items-center justify-content-between">
                <div class="col-md-5">
                  <img
                    src="/images/osquare.png"
                    alt="OSquare"
                    height="48"
                    loading="eager"
                  />

                  <h2 class="mt-4 mb-0">
                    {{ step == 0 ? "Sign in" : "Welcome" }}
                  </h2>

                  @if (step == 0) {
                    <p class="mt-3 mb-0">
                      with your OSquare Account. This account will be available
                      to other OSquare apps in the browser.
                    </p>
                  } @else {
                    <span
                      class="d-inline-block rounded-pill px-2 border border-secondary mt-3 py-1 fw-medium"
                      role="button"
                      (click)="goBack()"
                    >
                      <i class="bi bi-person-circle"></i> {{ email.value }}
                    </span>
                  }
                </div>

                <div class="col-md-5">
                  <div class="mb-3">
                    @if (step == 0) {
                      <input
                        type="text"
                        class="form-control shadow-none mb-1"
                        placeholder="Username"
                        formControlName="email"
                        #usrIn
                      />

                      @if (email.errors && email.touched) {
                        <small class="text-danger ms-2">
                          <i class="bi bi-exclamation-circle-fill me-1"></i>
                          @if (email.errors["required"]) {
                            Enter your username
                          }
                          @if (email.errors["invalid"]) {
                            Couldn't find your OSquare account.
                          }
                        </small>
                      }
                    } @else {
                      <input
                        [type]="showPassword ? 'text' : 'password'"
                        class="form-control shadow-none"
                        placeholder="Enter your password"
                        formControlName="password"
                        #pwdIn
                      />
                    }
                    @if (password.errors && password.touched) {
                      <small class="text-danger ms-2">
                        <i class="bi bi-exclamation-circle-fill me-1"></i>
                        @if (password.errors["required"]) {
                          Enter your password
                        }
                        @if (password.errors["invalid"]) {
                          Invalid credentials.
                        }
                      </small>
                    }
                    @if (authError && authErrorType === "field") {
                      <div
                        class="alert alert-danger py-2 px-3 small mt-2 rounded-3"
                      >
                        {{ authError }}
                      </div>
                    }
                  </div>

                  @if (step == 0) {
                    <p class="small text-muted">
                      <span class="fw-medium">Not your computer?</span>
                      Use incognito mode to sign in privately.
                    </p>
                  } @else {
                    <div class="form-check mb-2">
                      <input
                        class="form-check-input shadow-none"
                        type="checkbox"
                        id="show-password"
                        [(ngModel)]="showPassword"
                        [ngModelOptions]="{ standalone: true }"
                      />
                      <label
                        class="form-check-label user-select-none"
                        for="show-password"
                      >
                        Show password
                      </label>
                    </div>

                    <div class="text-end">
                      <button
                        type="button"
                        class="btn btn-link p-0 small fw-medium"
                        (click)="view = 'forgot'"
                      >
                        Forgot password?
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div
              class="card-footer bg-white border-0 text-end pt-4 p-5 rounded-bottom-4"
            >
              <button type="submit" class="btn btn-primary px-4">
                {{ step == 0 ? "Next" : "Login" }}
              </button>
            </div>
          </form>
        </div>
      } @else if (view === "forgot") {
        <div class="view-wrapper" [class.hidden]="view !== 'forgot'">
          <app-forgot-password
            [username]="email.value"
            (back)="view = 'login'"
          ></app-forgot-password>
        </div>
      } @else if (view === "restricted") {
        <div class="container-fluid bg-light">
          <div class="row justify-content-center align-items-center vh-100">
            <div class="col-12 col-md-6 col-lg-5">
              <div class="card shadow-sm border-0 rounded-4 p-5 text-center">
                @if (loading) {
                  <div class="loader mb-4"></div>
                }

                <img
                  src="/images/osquare.png"
                  alt="OSquare"
                  width="200"
                  class="mb-4 mx-auto d-block"
                />

                <div class="mb-4">
                  <i class="bi bi-shield-lock display-5 text-danger"></i>
                </div>

                <h3 class="mb-3">Access Restricted</h3>

                <p class="text-muted mb-4">
                  {{ authError }}
                </p>

                <div
                  class="alert alert-warning d-flex align-items-start gap-2 small mb-4"
                  role="alert"
                >
                  <i class="bi bi-info-circle mt-1"></i>
                  <div>
                    If you believe this is a mistake, please contact your system
                    administrator.
                  </div>
                </div>

                <button
                  class="btn btn-primary px-4"
                  type="button"
                  (click)="view = 'login'; authError = null"
                >
                  Back to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
